import { setAuthorised } from '~/actions/authorisedActions'

import { classNames } from '~/utils/classNames'

import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'

import Button from '../../Common/Button'

const Unauthorised = ({ fill }: { fill?: boolean }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const isNonProduction = import.meta.env.MODE !== 'production'

  return (
    <div className={classNames('relative h-full w-full grow', fill && '!fixed inset-0')}>
      <div className="z-8 absolute flex h-full w-full flex-col items-center justify-center bg-th-content">
        <p>You do not have permission to view this data.</p>
        <div className="mt-8 flex gap-4">
          <Button bordered onClick={() => navigate('/profile')}>
            View Permissions
          </Button>
          {isNonProduction && (
            <Button bordered onClick={() => dispatch(setAuthorised(true))}>
              Override Authentication
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default Unauthorised
